exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".red-text[data-v-25f50462]{color:#f5222d}.mb-footer-text[data-v-25f50462]{font-size:.94rem;color:#666;line-height:1.88rem;text-align:center}.mb-footer-text .title[data-v-25f50462]{color:#333;text-align:left;font-weight:500}.mb-footer-text .text[data-v-25f50462]{text-align:left}", ""]);

// exports
